import { AuthMessage, AuthMessageType } from '@playcastdotio/Messaging';
import { setIsReady } from '..';

export const handleAuthMessage = (message: AuthMessage) => {
  console.log('Auth message:', message);
  switch (message.type) {
    case AuthMessageType.AUTH_SUCCESS: {
      console.log('Auth success');
      setIsReady(true);
    }
  }
};
